import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageInterceptor implements HttpInterceptor {
  private translateService = inject(TranslateService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currentLanguage = this.translateService.getCurrentLang();

    const clonedRequest = req.clone({
      headers: req.headers.set('Accept-Language', currentLanguage),
    });

    return next.handle(clonedRequest);
  }
}
